import { c as _c } from "react/compiler-runtime";
import { TrustedHtml } from './trusted_html';
import { components } from '../apiV4';
import { decode } from 'html-entities';
import { formatAmount } from '../helpers/format_amount';
import type { FC, ReactNode, MouseEvent } from 'react';
export type FundraisingEvent = components['schemas']['FundraisingEventResult'] | components['schemas']['SearchResult'];
export type Links = components['schemas']['FundraisingEventResult']['links'] & components['schemas']['SearchResult']['links'];
export type FundraisingEventTeaserProps = {
  locale?: string;
  href?: string;
  font?: string;
  openInTab?: boolean;
  fundraisingEvent: FundraisingEvent;
  children?: ReactNode;
  onClick?: (event: MouseEvent, fundraisingEvent: FundraisingEvent) => void;
};
const pluralizeDonation = (locale: string, count: number) => {
  if (count === 1) return locale === 'de' ? 'Spende' : 'donation';
  return locale === 'de' ? 'Spenden' : 'donations';
};
export const FundraisingEventTeaser: FC<FundraisingEventTeaserProps> = t0 => {
  const $ = _c(56);
  const {
    fundraisingEvent,
    locale: t1,
    href: href_,
    onClick,
    openInTab,
    children
  } = t0;
  const locale = t1 === undefined ? document.documentElement.lang || "de" : t1;
  const href = href_ || (fundraisingEvent.links as Links).find(_temp)?.href;
  let t2;
  if ($[0] !== fundraisingEvent.profile_picture?.links) {
    t2 = fundraisingEvent.profile_picture?.links.find(_temp2)?.href;
    $[0] = fundraisingEvent.profile_picture?.links;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const fundraisingEventImageUrl = t2;
  let t3;
  if ($[2] !== fundraisingEvent.donated_amount_in_cents || $[3] !== locale) {
    t3 = formatAmount({
      cents: fundraisingEvent.donated_amount_in_cents,
      locale
    });
    $[2] = fundraisingEvent.donated_amount_in_cents;
    $[3] = locale;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const donationsAmount = t3;
  let t4;
  if ($[5] !== fundraisingEvent.contact?.picture?.links) {
    t4 = fundraisingEvent.contact?.picture?.links.find(_temp3)?.href;
    $[5] = fundraisingEvent.contact?.picture?.links;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const contactImageUrl = t4;
  let t5;
  if ($[7] !== fundraisingEvent || $[8] !== onClick) {
    t5 = event => {
      onClick?.(event, fundraisingEvent);
    };
    $[7] = fundraisingEvent;
    $[8] = onClick;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleClick = t5;
  let t6;
  if ($[10] !== fundraisingEvent.donations_count || $[11] !== locale) {
    t6 = pluralizeDonation(locale, fundraisingEvent.donations_count);
    $[10] = fundraisingEvent.donations_count;
    $[11] = locale;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const donationsTxt = t6;
  let t7;
  if ($[13] !== fundraisingEvent.title) {
    t7 = fundraisingEvent.title ? decode(fundraisingEvent.title) : "";
    $[13] = fundraisingEvent.title;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = openInTab ? "_blank" : "_parent";
  const t9 = `url(${fundraisingEventImageUrl})`;
  let t10;
  if ($[15] !== t9) {
    t10 = {
      backgroundImage: t9
    };
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== fundraisingEvent.title) {
    t11 = fundraisingEvent.title ? decode(fundraisingEvent.title) : "";
    $[17] = fundraisingEvent.title;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <div className="donatable-teaser--profile-picture" style={t10} title={t11} />;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== fundraisingEvent.title) {
    t13 = <TrustedHtml as="h2" className="donatable-teaser--title" value={fundraisingEvent.title} />;
    $[22] = fundraisingEvent.title;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = fundraisingEvent.contact?.name;
  let t15;
  if ($[24] !== t14) {
    t15 = <div><TrustedHtml as="span" value={t14} /></div>;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== fundraisingEvent.donations_count) {
    t16 = <span>{fundraisingEvent.donations_count}</span>;
    $[26] = fundraisingEvent.donations_count;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== donationsTxt || $[29] !== t16) {
    t17 = <div>{t16} {donationsTxt}</div>;
    $[28] = donationsTxt;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== donationsAmount) {
    t18 = <span>{donationsAmount}</span>;
    $[31] = donationsAmount;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  const t19 = locale === "de" ? "gesammelt" : "collected";
  let t20;
  if ($[33] !== t18 || $[34] !== t19) {
    t20 = <div>{t18} {t19}</div>;
    $[33] = t18;
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t15 || $[37] !== t17 || $[38] !== t20) {
    t21 = <div className="donatable-teaser--factlist">{t15}{t17}{t20}</div>;
    $[36] = t15;
    $[37] = t17;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      borderRadius: "50%",
      border: "1px solid #cccccc"
    };
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  const t23 = fundraisingEvent.contact?.name ?? "";
  let t24;
  if ($[41] !== contactImageUrl || $[42] !== t23) {
    t24 = <img style={t22} src={contactImageUrl} alt={t23} className="donatable-teaser--carrier-logo" />;
    $[41] = contactImageUrl;
    $[42] = t23;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== t21 || $[45] !== t24) {
    t25 = <div className="donatable-teaser--divider">{t21}{t24}</div>;
    $[44] = t21;
    $[45] = t24;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== children || $[48] !== handleClick || $[49] !== href || $[50] !== t12 || $[51] !== t13 || $[52] !== t25 || $[53] !== t7 || $[54] !== t8) {
    t26 = <a title={t7} onClick={handleClick} className="donatable-teaser" href={href} target={t8} rel="noreferrer">{children}{t12}{t13}{t25}</a>;
    $[47] = children;
    $[48] = handleClick;
    $[49] = href;
    $[50] = t12;
    $[51] = t13;
    $[52] = t25;
    $[53] = t7;
    $[54] = t8;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  return t26;
};
function _temp(link) {
  return link.rel === "platform";
}
function _temp2(link_0) {
  return link_0.rel === "fill_410x214";
}
function _temp3(link_1) {
  return link_1.rel === "fill_100x100";
}